import React, { useEffect, useState } from "react";

const DetailsModal = ({ item }) => {
  return (
    <div
      className={`flex z-[999999999999] flex-col
        justify-center gap-1 text-black`}
    >
      <div className="max-h-96 overflow-x-auto">
        <table className="table border-[1px] border-solid">
          <tbody className="">
            {/* start date */}
            <tr className="bg-white">
              <th className="border-r-[2px] border-solid">Date</th>
              <td className="">{item.date}</td>
            </tr>
            {/* bank name */}
            <tr className="h-max">
              <th className="border-r-[2px] border-solid">Bank Name</th>
              <td className="w-80">{item.bank_name}</td>
            </tr>
            {/* account number */}
            <tr className="h-max">
              <th className="border-r-[2px] border-solid">Account Number</th>
              <td className="w-80">{item.account_number}</td>
            </tr>
            {/* payment source */}
            <tr className="h-max">
              <th className="border-r-[2px] border-solid">Payment Source</th>
              <td className="w-80">{item.payment_source}</td>
            </tr>
            {/* total amount */}
            <tr className="h-max">
              <th className="border-r-[2px] border-solid">Total Amount</th>
              <td className="w-80">{item.totalAmount}</td>
            </tr>
            {/* remarks */}
            <tr className="h-max">
              <th className="border-r-[2px] border-solid">Remarks</th>
              <td className="w-80">{item.remarks}</td>
            </tr>
            {/* image */}
            {item.image && (
              <tr className="h-max">
                <th className="border-r-[2px] border-solid">Image</th>
                <td className="w-80">
                  <img src={item.image} className="w-full h-auto" />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DetailsModal;
